// Pre-seeded recent activity. The Activity feed displays these
// alongside any scenario-driven events so the feed is alive on
// first load. CLAUDE.md §1 — content data, single source.

export interface SeedActivity {
  id: string;
  kind: "ingest" | "ruleFire" | "alert" | "memoryMatch" | "substitute" | "memoryPromote" | "explain" | "budgetSlip" | "styleDrift" | "approvalAged";
  label: string;
  detail: string;
  badge?: "warn" | "info" | "ok" | "money";
  delta?: string;
  /** Display string only — not a real timestamp. */
  when: string;
}

export const SEED_ACTIVITY: SeedActivity[] = [
  {
    id: "act-1",
    kind: "ruleFire",
    label: "Rule R-lead-time fired",
    detail: "Pendant chandelier · L-887 · 92-day lead exceeds milestone slack",
    badge: "warn",
    when: "2 min ago",
  },
  {
    id: "act-2",
    kind: "memoryMatch",
    label: "Memory Card mc1 matched",
    detail: "7 prior accepts on the same 90-day chandelier pattern",
    badge: "ok",
    when: "2 min ago",
  },
  {
    id: "act-3",
    kind: "substitute",
    label: "Substitute proposed · L-901",
    detail: "Pendant L-901 · 14 d · 88% style · ΔPrice +₹7,000",
    badge: "money",
    delta: "−78 d · 88% style",
    when: "1 min ago",
  },
  {
    id: "act-4",
    kind: "ingest",
    label: "BOQ row appended",
    detail: "Quartz countertop · vendor v4 · ₹72,000 · 21 d lead",
    badge: "info",
    when: "18 min ago",
  },
  {
    id: "act-5",
    kind: "approvalAged",
    label: "Approval ageing watch",
    detail: "Kitchen palette pending 4 d · escalation threshold 5 d",
    badge: "info",
    when: "33 min ago",
  },
  {
    id: "act-6",
    kind: "ingest",
    label: "Scene saved · 14 placements",
    detail: "Living + Kids Bedroom updated · constraint pass clean",
    badge: "ok",
    when: "1 h ago",
  },
  {
    id: "act-7",
    kind: "memoryPromote",
    label: "Memory Card mc5 promoted",
    detail: "RERA filing packet · 6 accepts · 0 rejects · studio-scope",
    badge: "ok",
    when: "yesterday",
  },
];
